export default "__VITE_ASSET__qRDcxSM8__"